
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandK as ObiOwnShipNoCommandKElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-k.js';
 
 
 

 
 export const ObiOwnShipNoCommandK = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-k',
   elementClass: ObiOwnShipNoCommandKElement,
   events: {
     
   }
  });
 
 